import {
  BaseModal,
  Button,
  Content,
  Flex,
  fromTheme,
  IconButton,
  StrokeIcon,
} from '@acsbe/ui';
import { styled } from 'styled-components';
import expiredTrialPopup from '../../assets/expiredTrialPopup.png';
import { APPLICATION_MODES, useApplicationViewState } from '../../context';

interface TrialExpiredPopupProps {
  onClose: () => void;
  onChoosePlan: () => void;
}

export const TrialExpiredPopup = (props: TrialExpiredPopupProps) => {
  const { applicationMode } = useApplicationViewState();

  const onClose = () => {
    props.onClose();
  };

  const onChoosePlan = () => {
    props.onChoosePlan();
  };

  return (
    <>
      <>
        <StyledModal open={true} closeButton>
          <Flex>
            <img
              src={expiredTrialPopup}
              style={{ maxWidth: '100%', height: '247px', objectFit: 'cover' }}
            />
          </Flex>
          <CloseButton
            aria-label="Close"
            padding={1.5}
            scale="alternative"
            variant="solid"
            radius="round"
            onClick={() => onClose()}
          >
            <StrokeIcon name="Close" size="lg" />
          </CloseButton>
          <Flex padding={8} paddingBlockStart={10} gap={8}>
            <Flex>
              <Flex gap={4}>
                <Heading>Your trial has expired!</Heading>
                <SubHeading>
                  accessWidget is turned off and your store may no longer be
                  accessible.
                  {applicationMode !== APPLICATION_MODES.LIMITED &&
                    ' Choose a plan to help keep your store inclusive and your business mitigate legal risk.'}
                </SubHeading>
              </Flex>
            </Flex>
            {applicationMode !== APPLICATION_MODES.LIMITED && (
              <Flex gap={4} justify="end" row>
                <Button
                  scale="primary"
                  fullWidth
                  onClick={() => {
                    onChoosePlan();
                  }}
                  data-mixpanel="choose-a-plan-trial-expired-popup"
                >
                  <span>Choose a plan</span>
                </Button>
              </Flex>
            )}
          </Flex>
        </StyledModal>
      </>
    </>
  );
};

const StyledModal = styled(BaseModal)`
  max-width: 520px;
`;

const CloseButton = styled(IconButton)`
  position: absolute;
  inset-block-start: 5px;
  inset-inline-end: 5px;
  background-color: #e0eafe;
  background-color: transparent;
  color: #394c61;
`;

const Heading = styled(Flex)`
  text-align: center;
  font-size: 24px;
  font-weight: 700;
  @media ${fromTheme('viewport.uptoPhablet')} {
    font-size: 20px;
  }
`;

const SubHeading = styled(Content)`
  text-align: center;
  font-size: 18px;
  line-height: 27px;
  @media ${fromTheme('viewport.uptoPhablet')} {
    font-size: 14px;
    line-height: 21px;
  }
`;
